import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PhoneNumberValidator {
  constructor() { }

  phoneNumberValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void | undefined {
    // Check if field is empty
    const isEmpty =
      formField.value === '' ||
      formField.value === undefined ||
      formField.value === null;

    // // Required - Can't be empty
    // if (isEmpty) {
    //   return { empty: { valid: false, value: formField.value } };
    // }

    // Minimun 6 digits
    const notEnough = /^\d( ?\d){0,4}$/.test(formField.value);
    if (notEnough) {
      return { min: { valid: false, value: formField.value } };
    }

    // Maximun 10 digits
    const tooMany = /^\d( ?\d){10,}$/.test(formField.value);
    if (tooMany) {
      return { max: { valid: false, value: formField.value } };
    }

    // Must only be letters
    const ausPhoneFormat =
      /^$|^13\d{4}$|^13[\d ]{6}$|^(1800\d{6} ?)$|^(1800[\d ]{8} ?)$|^(1300\d{6})$|^(1300[\d ]{8})$|^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/.test(
        formField.value
      );
    if (!isEmpty && !ausPhoneFormat) {
      return { wrongFormat: { valid: false, value: formField.value } };
    }
  }
}
